import { fetchData } from 'api/services/mediaPlanning/utils';
import { ApiResponse } from 'api/services/mediaPlanning/types';
import { CAMPAIGN } from './mediaPlanning';
import { CountryFormState } from '../../../store/planStore';

export interface PredictionStatus {
  code: number;
  status: string;
  description: string;
}

export interface CountryPredictionStatuses {
  country: string;
  mainStatus: PredictionStatus;
  partialStatus: PredictionStatus;
  metaCampaignId: string;
  mainPredictionId: string;
}

export const getMetaPredictionStatuses = async (
  mediaPlanId: string
): Promise<CountryPredictionStatuses[]> => {
  const response = await fetchData<ApiResponse<any>>(
    `/${CAMPAIGN}/meta-predictions?mediaPlanId=${mediaPlanId}`
  );

  const result = response.data.map((countryEntry: Record<string, any>) => {
    const [country] = Object.keys(countryEntry);
    const { predictionsSet, campaign } = countryEntry[country];

    return {
      country,
      mainStatus: predictionsSet.mainPrediction.status,
      partialStatus: predictionsSet.partialPrediction?.status || null,
      metaCampaignId: campaign.id,
      mainPredictionId: predictionsSet.mainPrediction.id,
    };
  });

  return result;
};
